import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const LocationFilter = ({ locations, selectedLocations, onLocationToggle }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedAreas, setExpandedAreas] = useState({});

  const toggleArea = (areaId) => {
    setExpandedAreas(prev => ({
      ...prev,
      [areaId]: !prev?.[areaId]
    }));
  };

  const handleLocationToggle = (locationId) => {
    if (onLocationToggle && typeof onLocationToggle === 'function') {
      onLocationToggle(locationId);
    }
  };

  const filteredLocations = locations?.filter(location =>
    location?.area?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    location?.districts?.some(d => d?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()))
  );

  return (
    <div className="bg-card rounded-lg border border-border p-4 shadow-warm h-full flex flex-col">
      <div className="mb-4">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="MapPin" size={20} color="var(--color-primary)" />
          تصفية حسب الموقع
        </h3>
        <Input
          type="search"
          placeholder="ابحث عن منطقة أو حي..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          className="w-full"
        />
      </div>
      <div className="flex-1 overflow-y-auto space-y-2">
        {filteredLocations?.map((location) => (
          <div key={location?.id} className="border border-border rounded-lg overflow-hidden">
            <button
              onClick={() => toggleArea(location?.id)}
              className="w-full flex items-center justify-between p-3 hover:bg-muted transition-colors duration-200"
            >
              <div className="flex items-center gap-2">
                <Icon 
                  name={expandedAreas?.[location?.id] ? 'ChevronDown' : 'ChevronLeft'} 
                  size={16} 
                />
                <span className="text-sm font-medium text-foreground">{location?.area}</span>
              </div>
              <span className="text-xs font-data text-muted-foreground bg-muted px-2 py-1 rounded-full" dir="ltr">
                {location?.count}
              </span>
            </button>

            {expandedAreas?.[location?.id] && (
              <div className="bg-muted/50 p-2 space-y-1">
                {location?.districts?.map((district) => (
                  <label
                    key={district?.id}
                    className="flex items-center justify-between p-2 hover:bg-card rounded cursor-pointer transition-colors duration-200"
                  >
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={selectedLocations?.includes(district?.id)}
                        onChange={() => handleLocationToggle(district?.id)}
                        className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
                      />
                      <span className="text-sm text-foreground">{district?.name}</span>
                    </div>
                    <span className="text-xs font-data text-muted-foreground" dir="ltr">
                      {district?.count}
                    </span>
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationFilter;